import { Spin, Timeline, Typography } from 'antd';
import dayjs from 'dayjs';
import _ from 'lodash';
import React, { ReactElement, ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IGlobalState } from '~reducer';
import Layout from './Layout';
import { abaHistoriesListAction } from '~WarehouseLoanTransactionAbas/actions';
import IWarehouseLoanTransactionAbaHistory from '~Api/WarehouseLoanTransactionAba/IWarehouseLoanTransactionAbaHistory';
import { abaHistoriesSelector } from '~WarehouseLoanTransactionAbas/selectors';

export default function History(): ReactElement {
    const { warehouseLoanTransactionAbaUuid } = useParams<{ warehouseLoanTransactionAbaUuid: string }>();

    const histories: IWarehouseLoanTransactionAbaHistory[] = useSelector((state: IGlobalState) => abaHistoriesSelector(state, warehouseLoanTransactionAbaUuid));

    const dispatch: Dispatch = useDispatch();

    useEffect(() => {
        if (!histories) {
            dispatch(abaHistoriesListAction(warehouseLoanTransactionAbaUuid));
        }
    }, [
        dispatch,
        histories,
        warehouseLoanTransactionAbaUuid,
    ]);

    if (!histories) {
        return (
            <Layout
                pageTitle='History'
                section='history'
                uuid={warehouseLoanTransactionAbaUuid}
            >
                <Typography.Title level={2}>History</Typography.Title>
                <Spin/>
            </Layout>
        );
    }

    const historiesBlock: ReactNode[] = _.sortBy(histories, [ 'createdTime' ]).map((history: IWarehouseLoanTransactionAbaHistory) => (
        <Timeline.Item
            key={history.uuid}
            label={dayjs(history.createdTime).format('YYYY-MM-DD - HH:mm')}
        >
            <Typography.Text>{history.description}</Typography.Text>
        </Timeline.Item>
    ));

    return (
        <Layout
            pageTitle='History'
            section='history'
            uuid={warehouseLoanTransactionAbaUuid}
        >
            <Typography.Title level={2}>History</Typography.Title>
            <Timeline mode='left' reverse={true}>
                {historiesBlock}
            </Timeline>
        </Layout>
    );
}